import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ApolloClient from "apollo-client";
import React, { PureComponent } from "react";
import { ApolloConsumer } from "react-apollo";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import Loading from "../../../componentes/Loading/Loading";
import { xSmallTableStyle } from "../../../componentes/Table/smallTableStyle";
import { GetPainelCadastroComponent, GetPainelCadastroQuery } from "../../../graphql/components";
import { selectOperadoraToEdit } from "../../../redux/actions/painelCadastroActions";
import { comTelaEstreita, ComTelaEstreita } from "../../../utils/viewport";
import CardTableMobile from "./cardTableMobile";
import { statusChip } from "./statusPainelCadastro";
import { exigeTermoAdesao, MENSAGEM_TERMO_NAO_EXIGIDO } from "./termoAdesaoOperadora";
import "./painelCadastro.css";

interface Props extends ComTelaEstreita {
  classes?: any;
  openListaEC: () => void;
  openCadastroTaxa: (nomeOperadora: string, codOperadora: number, mensagem: string) => void;
  mensagemRetorno: (msg: boolean) => void;
  selectOperadoraToEdit: typeof selectOperadoraToEdit;
  download: (tipoDocumento: string, client: ApolloClient<any>, codoperadora: number) => void;
  upload: (codoperadora: number, tipoDocUpload: string) => void;
}

class TablePainelCadastro extends PureComponent<Props> {
  selectOperadora = (operadora: any) => {
    this.cadastrarEC(operadora.operadora.nome, operadora.operadora.codoperadora);
  };

  cadastrarEC = (nomeOperadora: string, codOperadora: number) => {
    this.props.openListaEC();
    this.props.selectOperadoraToEdit(nomeOperadora, codOperadora);
  };

  getButton = (operadora: any) => {
    const ec = statusChip(operadora.statusEC!.descricao, "cadastro");
    return (
      <Button
        size="small"
        style={{ padding: 0, paddingLeft: 8, paddingRight: 8 }}
        className={`painelDocumentosBotao ${ec.classe}`}
        onClick={this.selectOperadora.bind(this, operadora)}
      >
        {ec.label}
      </Button>
    );
  };

  getRows = (data: GetPainelCadastroQuery) => {
    const { classes } = this.props;
    return data.getPainelCadastro.map((operadora) => {
      const buttonEC = this.getButton(operadora);
      const autorizacao = statusChip(operadora.statusCarteira.descricao!, "documento");
      const adesao = statusChip(operadora.statusTermo.descricao!, "documento");
      const taxa = statusChip(operadora.statusTaxa!.descricao!, "cadastro");
      const possuiAdesao = exigeTermoAdesao(operadora.statusTermo.descricao);
      return (
        <TableRow key={operadora.operadora.codoperadora} className={classes.row}>
          <TableCell>{operadora.operadora.nome}</TableCell>
          <ApolloConsumer>
            {(client) => (
              <React.Fragment>
                <TableCell>
                  <Button
                    size="small"
                    style={{ padding: 0, paddingLeft: 8, paddingRight: 8 }}
                    className={`painelDocumentosBotao download`}
                    onClick={this.props.download.bind(this, "INSTRUCAO", client as any, operadora.operadora.codoperadora!)}
                  >
                    Visualizar
                  </Button>
                </TableCell>
                <TableCell>
                  <Button
                    size="small"
                    style={{
                      padding: 0,
                      paddingLeft: 8,
                      paddingRight: 8,
                      marginRight: 15,
                    }}
                    className={`painelDocumentosBotao download`}
                    onClick={this.props.download.bind(this, "CARTA_INTERVAN", client as any, operadora.operadora.codoperadora!)}
                  >
                    Baixar
                  </Button>
                  <Button
                    size="small"
                    onClick={this.props.upload.bind(this, operadora.operadora.codoperadora!, "CARTA_INTERVAN")}
                    style={{ padding: 0, paddingLeft: 8, paddingRight: 8 }}
                    className={`painelDocumentosBotao ${autorizacao.classe}`}
                  >
                    {autorizacao.label}
                  </Button>
                </TableCell>
                <TableCell>
                  {!possuiAdesao && (
                    <span className="painelDocumentosSemTermo" title={MENSAGEM_TERMO_NAO_EXIGIDO} aria-label={MENSAGEM_TERMO_NAO_EXIGIDO}>
                      —
                    </span>
                  )}
                  {possuiAdesao && (
                    <>
                      <Button
                        size="small"
                        style={{ padding: 0, paddingLeft: 8, paddingRight: 8 }}
                        className={`painelDocumentosBotao download`}
                        onClick={this.props.download.bind(this, "TERMO_ADESAO", client as any, operadora.operadora.codoperadora!)}
                      >
                        Baixar
                      </Button>
                      <Button
                        size="small"
                        style={{ padding: 0, paddingLeft: 8, paddingRight: 8, marginLeft: 15 }}
                        onClick={this.props.upload.bind(this, operadora.operadora.codoperadora!, "TERMO_ADESAO")}
                        className={`painelDocumentosBotao ${adesao.classe}`}
                      >
                        {adesao.label}
                      </Button>
                    </>
                  )}
                </TableCell>
              </React.Fragment>
            )}
          </ApolloConsumer>
          <TableCell>{buttonEC}</TableCell>
          <TableCell title={operadora.statusTaxa!.descricao === "aprovado" ? "Já existe um plano cadastrado." : ""}>
            <Button
              disabled={operadora.statusTaxa!.descricao === "aprovado"}
              size="small"
              style={{ padding: 0, paddingLeft: 8, paddingRight: 8 }}
              onClick={this.props.openCadastroTaxa.bind(
                this,
                operadora.operadora.nome!,
                operadora.operadora.codoperadora!,
                operadora.operadora!.estabelecimentoCadastroTaxa!
              )}
              className={`painelDocumentosBotao ${taxa.classe}`}
            >
              {taxa.label}
            </Button>
          </TableCell>
        </TableRow>
      );
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <GetPainelCadastroComponent>
        {({ data, loading, error }) => {
          if (loading) return <Loading />;
          if (error) return null;
          if (!this.props.telaEstreita) {
            return (
              <div className="painelCard">
                <Table className="painelTabela">
                  <TableHead>
                    <TableRow className="painelTabelaHead">
                      <TableCell>Operadora</TableCell>
                      <TableCell>Instrução</TableCell>
                      <TableCell>Termo de autorização</TableCell>
                      <TableCell>Termo de adesão</TableCell>
                      <TableCell>Código de estabelecimento</TableCell>
                      <TableCell>Taxas</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{this.getRows(data!)}</TableBody>
                </Table>
              </div>
            );
          } else {
            return (
              <ApolloConsumer>
                {(client) => (
                  <>
                    {data!.getPainelCadastro.map((operadora) => (
                      <CardTableMobile
                        key={operadora!.operadora!.codoperadora!}
                        linha={operadora!}
                        client={client as any}
                        download={this.props.download}
                        upload={this.props.upload}
                        cadastrarEC={this.cadastrarEC}
                        cadastrarTaxa={this.props.openCadastroTaxa}
                      />
                    ))}
                  </>
                )}
              </ApolloConsumer>
            );
          }
        }}
      </GetPainelCadastroComponent>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectOperadoraToEdit: bindActionCreators(selectOperadoraToEdit, dispatch),
});

const TablePainelCadastroMapped = connect(
  null,
  mapDispatchToProps
)(TablePainelCadastro);

export default comTelaEstreita<any>(withStyles(xSmallTableStyle as any)(TablePainelCadastroMapped));
